declare const __VERSION_PLACEHOLDER__: string;
declare const __VERSION_MINOR__: number;

const buildNumber = {
  BUILD_NUMBER: "###VERSION###",
  BUILD_NUMBER_MINOR: -1,
};

export function setBuildNumber(buildNo: string | undefined): void {
  if (buildNo) {
    buildNumber.BUILD_NUMBER = buildNo;
    if (buildNo.includes(".")) {
      const buildNumberParts = buildNo.split(".");
      buildNumber.BUILD_NUMBER_MINOR = parseInt(
        (buildNumberParts[0] || "").concat(
          (buildNumberParts[1] || "").padStart(3, "0")
        ),
        10
      );
    }
  }
}

export function getBuildNumber(): string {
  // if __VERSION_PLACEHOLDER__ doesn't equal "###VERSION###", it means the build number is set by webpack to signify a development build
  // otherwise, we should use the build number from buildNumber.BUILD_NUMBER which is passed from OWL
  try {
    if (__VERSION_PLACEHOLDER__ !== "###VERSION###") {
      return __VERSION_PLACEHOLDER__;
    }
    return buildNumber.BUILD_NUMBER;
  } catch (_) {
    return buildNumber.BUILD_NUMBER;
  }
}

export function getBuildNumberMinor(): number {
  // if __VERSION_MINOR__ doesn't equal -1, it means the build number is set by webpack to signify a development build
  // otherwise, we should use the build number from buildNumber.BUILD_NUMBER_MINOR which is passed from OWL
  if (__VERSION_MINOR__ !== -1) {
    return __VERSION_MINOR__;
  }
  return buildNumber.BUILD_NUMBER_MINOR;
}

export const DEBUG_SUFFIX =
  process.env.NODE_ENV !== "production" ? ".Debug" : "";
export const MIN_SUFFIX = process.env.NODE_ENV !== "production" ? "" : ".min";

/*
 * Refactors Build Version to look like 161082430000 from 16.0.10824.30000
 */
export function getVersionNumberFromVersionName(version: string): string {
  if (process.env.NODE_ENV !== "production") {
    // Skip version checks for debug builds
    return version;
  }

  if (!version) {
    throw new Error("Build number not available");
  }

  const versionParts = version.split(".");
  if (versionParts.length !== 4) {
    throw new Error("Build number has incorrect format");
  }

  const staticContentVersion =
    versionParts[0] + versionParts[2] + versionParts[3];
  return staticContentVersion;
}

/*
 * Build number looks like 16.0.10824.30000, we want it to look like 161082430000
 */
export function getContentVersion(): string {
  return getVersionNumberFromVersionName(getBuildNumber());
}

export function isWiseDeployedJSApi(appBootStrapperUrl: string): boolean {
  if (process.env.NODE_ENV !== "production") {
    // Skip version checks for debug builds
    return true;
  }

  if (appBootStrapperUrl.includes("wise")) {
    return true;
  }

  return false;
}
